export const usCaMap: Record<string, boolean> = {
  US: true,
  CA: true,
};
